export default __webpack_public_path__ + "static/media/rescue-lc-ico.663aa06b.svg";